<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>PEDIDOS EM MANUTENÇÃO (PENDENTES)</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <alert
            :visible="!!error"
            dark
            type="error"
            :message="error"
            :clickClose="() => (error = '')"
          />
          <alert
            :visible="!!alertSuccess"
            dark
            type="success"
            :message="alertSuccess"
            :clickClose="() => (alertSuccess = '')"
          />
          <v-row>
            <v-col>
              <v-data-table
                :headers="headers"
                :loading="loading"
                :items="drafts"
                :search="search"
                sort-by="created_at"
                class="elevation-1"
                dense
              >
                <!-- eslint-disable-next-line -->
                <template v-slot:item.created_at="{ item }">
                  {{ item.created_at | datetimeFormatBr }}
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.franchise="{ item }">
                  {{ item.franchise_code }} - {{ item.franchise_name }}
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.provider="{ item }">
                  {{ item.provider_code }} - {{ item.provider_name }}
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.products="{ item }">
                  <td class="text-right">{{ item.products.length }}</td>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.items="{ item }">
                  <td class="text-right">{{ item.quantity_items }}</td>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.value="{ item }">
                  {{ item.value | currencyEuaToBr }}
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.actions="{ item }">
                  <v-tooltip top color="blue darken-1">
                    <!-- eslint-disable-next-line -->
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="mr-2"
                        color="blue darken-1"
                        @click="editOrder(item.id)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top color="error">
                    <!-- eslint-disable-next-line -->
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        color="red darken-1"
                        @click="removeOrder(item.id)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Deletar</span>
                  </v-tooltip>
                </template>
              </v-data-table>
              <!-- <v-simple-table dense fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left fs-12 text-no-wrap">Pedido</th>
                      <th class="text-left fs-12 text-no-wrap">Franqueado</th>
                      <th class="text-left fs-12 text-no-wrap">Fornecedor</th>
                      <th class="text-right fs-12 text-no-wrap">Produtos</th>
                      <th class="text-right fs-12 text-no-wrap">Quantidade</th>
                      <th class="text-right fs-12 text-no-wrap">Valor</th>
                      <th class="text-left fs-12 text-no-wrap">Data</th>
                      <th class="text-left fs-12 text-no-wrap">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in drafts" :key="`${item.id}`">
                      <td>{{ item.franchise_code }} - {{ item.code }}</td>
                      <td>
                        {{ item.franchise_code }} - {{ item.franchise_name }}
                      </td>
                      <td>
                        {{ item.provider_code }} - {{ item.provider_name }}
                      </td>
                      <td class="text-right">{{ item.products.length }}</td>
                      <td class="text-right">{{ item.quantity_items }}</td>
                      <td class="text-right">
                        {{ item.value | currencyEuaToBr }}
                      </td>
                      <td>{{ item.created_at | dateFormatBr }}</td>
                      <td>
                        
                      </td>
                    </tr>
                    <tr v-if="drafts.length === 0">
                      <td
                        colspan="8"
                        class="text-center grey--text text-subtitle-2 pa-4"
                      >
                        Não existe pedidos em manutenção
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table> -->
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog v-model="dialogRemoveOrder" persistent max-width="480px">
      <v-card>
        <v-card-title>Deletar Pedido</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          Deseja Realmente deletar esse pedido?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="handleCancelRemoveOrder()">
            Fechar
          </v-btn>
          <v-btn
            color="red darken-3"
            class="white--text"
            outlined
            @click="handleConfirmRemoveOrder()"
          >
            <v-icon left>mdi-delete</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";
import * as HTTP from "@/api/requests/base";

export default {
  components: {
    Alert,
  },
  data: () => ({
    headers: [
      {
        text: "Pedido",
        align: "right",
        value: "code",
        width: 100,
      },
      { text: "Franqueado", value: "franchise", width: 200 },
      { text: "Fornecedor", value: "provider", width: 200 },
      { text: "Produtos", value: "products", width: 100 },
      { text: "Quantidade", value: "items", width: 100 },
      { text: "Valor", value: "value", width: 100 },
      { text: "Data", value: "created_at", width: 100 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    search: "",
    loading: false,
    drafts: [],
    error: "",
    alertSuccess: "",
    valid: true,
    lazy: false,
    radioGroupDraft: 0,
    dialogRemoveOrder: false,
    item_delete: "",
    companySessionSelected: {
      id: "",
    },
  }),
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    dateFormatBr: function (value) {
      let [date, hours] = value.split(" ");
      date = date.split("-").reverse().join("/");
      return `${date} ${hours}`;
    },
  },
  created() {
    let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
    if (session) {
      session = JSON.parse(session);
      if (
        session.company_selected !== "" &&
        session.company_selected !== undefined
      ) {
        this.companySessionSelected = session.company_selected;
      }
      this.initialize();
    } else {
      this.initialize();
    }
    // this.initialize();
  },
  methods: {
    async initialize() {
      this.verifyDraftOrders();
    },
    async verifyDraftOrders() {
      this.drafts = [];
      this.loading = true;
      try {
        let url = `${URL}order/draft`;
        if (this.companySessionSelected.id !== "") {
          url = `${url}?franchise_id=${this.companySessionSelected.id}`;
        }
        const response = await fetch(url);
        let data = await response.json();
        console.log(data);
        if (data.length > 0) {
          this.drafts = data;
          this.drafts = this.drafts.map((item) => ({
            ...item,
            code: `${item.franchise_code} - ${item.code}`,
          }));
        }
      } catch (error) {
        console.log(error);
        this.error =
          "Atenção: Não foi possível carregar os pedidos manutenção, tente novamente mais tarde";
      } finally {
        this.loading = false;
      }
    },
    editOrder(id) {
      console.log(id);
      this.$router.push({ name: "CreateInvoice", params: { id: id } });
    },
    removeOrder(id) {
      console.log(id);
      this.item_delete = id;
      this.dialogRemoveOrder = true;
    },
    handleCancelRemoveOrder() {
      this.item_delete = "";
      this.dialogRemoveOrder = false;
    },
    handleConfirmRemoveOrder() {
      this.dialogRemoveOrder = false;
      this.$vuetify.goTo(0, {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      });
      this.deleteOrderDraft(this.item_delete);
    },
    async deleteOrderDraft(id) {
      this.loading = true;
      try {
        const response = await fetch(`${URL}order/${id}`, {
          method: "DELETE",
        });
        let data = await response.json();
        this.alertSuccess = "Pedido Deletado com Sucesso";
        this.verifyDraftOrders();
        console.log(data);
      } catch (error) {
        console.log(error);
        this.error =
          "Atenção: Não foi possível deletar este pedido, tente novamente mais tarde";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 13px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
.image-clickable {
  cursor: pointer;
}
.cart-editing {
  background-color: #ffab00;
}
.v-text-field--outlined.border-color-field >>> fieldset {
  border-color: #666;
}
</style>
